import React from "react";
import { Routes } from "react-router-dom";

import rootRoutes from "./routes/root";
import errorRoutes from "./routes/error";
import locationRoutes from "./routes/location";
import customerRoutes from "./routes/customer";
import publicTasksRoutes from "./routes/PublicTasks";
import authRoutes from "./routes/auth";

import firstMileRoutes from "./routes/firstMile";
import lastMileRoutes from "./routes/lastMile";
import shippingCompanyRoutes from "./routes/shippingCompany";
import freelanceDriverRoutes from "./routes/freelanceDriver";
import guardRoutes from "./routes/guard";
import driverRoutes from "./routes/driver";
import adminRoutes from "./routes/admin";
import merchantRoutes from "./routes/merchant";
import { ROLES, USER_ROLES } from "src/constants";

const MapitRoutes = ({ currentUser }) => {
  let roleRoutes = null
  if (currentUser?.merchant?.role === ROLES.shippingCompany && currentUser?.role === USER_ROLES.MERCHANT) {
    if (currentUser?.merchant?.shippingType === "FIRST_MILE" || currentUser?.merchant?.shippingType === "FIRST_MILE") {
      roleRoutes = firstMileRoutes(currentUser)
    } else if (currentUser?.merchant?.shippingType === "LAST_MILE" || currentUser?.merchant?.shippingType === "LAST_MILE") {
      roleRoutes = lastMileRoutes(currentUser)
    } else {
      roleRoutes = shippingCompanyRoutes(currentUser)
    }
  } else if (currentUser?.role === ROLES.freelanceDriver) {
    roleRoutes = freelanceDriverRoutes(currentUser)
  } else if (currentUser?.role === USER_ROLES.WAREHOUSE) {
    roleRoutes = guardRoutes(currentUser)
  } else if (currentUser?.merchant?.role === ROLES.driver) {
    roleRoutes = driverRoutes(currentUser)
  } else if (currentUser?.role === ROLES.admin) {
    roleRoutes = adminRoutes(currentUser)
  } else if (currentUser?.merchant?.role === ROLES.merchant) {
    roleRoutes = merchantRoutes(currentUser)
  }

  return (
    <Routes>
      {errorRoutes()}
      {locationRoutes()}
      {customerRoutes()}
      {publicTasksRoutes()}
      {roleRoutes}
      {authRoutes(currentUser)}
      {rootRoutes(currentUser)}
    </Routes>
  )
};

export default MapitRoutes;
